import type { TourDefinition } from '../types';

export const FIRST_TALENT_POOL_TOUR_ID = 'first-talent-pool';

export const talentPoolScoredTour: TourDefinition = {
  id: FIRST_TALENT_POOL_TOUR_ID,
  steps: [
    {
      kind: 'modal',
      eyebrow: 'YOUR FIRST SCORED CANDIDATES',
      title: 'Beacon will complete 100% of the scores.',
      body: 'Beacon is determining how each candidate is measuring up to your hiring bar. Importantly, Beacon also leverages BreakLine’s deep, performance-driven pattern-recognition methodology.',
      primaryLabel: 'Show me',
      skipLabel: 'Not now',
    },
    {
      target: 'tp-recommendation',
      placement: 'left',
      title: 'The recommendation',
      body: 'At a glance: who to screen, who to keep warm, and who to pass on, based on how each candidate stacks up against your bar.',
    },
    {
      target: 'tp-expand',
      placement: 'right',
      advance: 'click',
      waitHint: 'Click to expand',
      title: 'See the evidence',
      body: 'Click the arrow to open a candidate and see how they scored against every criterion, with the evidence cited from their own history.',
    },
    {
      target: 'tp-evidence',
      placement: 'top',
      title: 'Every criterion, with citations',
      body: 'This is the why behind the score. Each criterion is rated and backed by evidence, so a recommendation is something you can check rather than trust.',
    },
    {
      target: 'tp-actions',
      placement: 'bottom',
      title: 'Pipeline or archive',
      body: 'Move the strongest into your pipeline and archive the rest. Your pipeline builds itself, with the reasoning already attached.',
      primaryLabel: 'Finish',
    },
  ],
};
